import React from 'react';
import { MapGeneralController } from 'src/feature-app';
import { JourneyLeadsController } from './';

/**
 * Este componente está creado únicamente para que JourneyLeadsController tenga acceso a las variables de MapGeneralController.
 */
export const JourneyLeadsWrapper = () => {
	return (
		<MapGeneralController>
			<JourneyLeadsController />
		</MapGeneralController>
	);
};
